<template>
  <StudioMultiSelect
    v-model="sacTypesSelected"
    :searchable="true"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === minimumFilterView && sacTypesSelected.length === items.length"
        class="sac-filter__placeholder"
      >
        {{ placeholder }}
      </span>
      <template v-else-if="sacTypesSelected.length !== items.length">
        <span
          v-if="index === minimumFilterView"
          class="grey--text caption"
        >
          {{ sacTypesSelected.length }} {{ message }}
        </span>
      </template>
    </template>
  </StudioMultiSelect>
</template>

<script>
import sacTypeModel from '@/mixins/sac-type-model';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import pagesModel from '@/mixins/pages-model';

export default {
  name: 'SacTypeFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    sacTypeModel,
    pagesModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    channels: {
      type: Array,
      default: () => ([]),
    },
    selectItems: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      default: 'Interações',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholder: 'Indiferente',
      minimumFilterView: 0,
    };
  },
  computed: {
    sacTypesSelected: {
      get() {
        const types = this.value?.value;
        if (!types || types[0] === 'All') {
          return [];
        }
        return this.value.value;
      },
      set(newValue) {
        let newTypes = newValue;
        if (!newValue?.length) {
          newTypes = this.items.map(v => v && v.value);
          return this.$emit('input', { value: ['All', ...newTypes] });
        }

        if (typeof (newValue[0]) === 'object') {
          newTypes = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newTypes,
        });
      },
    },
    items() {
      const channelList = this.channels.length > 0 ? this.channels : this.allUniqueChannels;
      const { selectItems } = this;
      const typeList = selectItems && selectItems.length
        ? selectItems
        : this.getTypesByChannels(channelList);
      return typeList.map(type => {
        const { name: text, value } = this.typesObj[type];
        return { text, value };
      });
    },
    message() {
      return this.sacTypesSelected.length - this.minimumFilterView === 1 ? 'selecionado' : 'selecionados';
    },
  },
  watch: {
    channels() {
      this.checkValidSelections();
    },
  },
  methods: {
    // Prevents unreachable options after updating
    // Pages filter from remaining selected
    checkValidSelections() {
      const { items, sacTypesSelected } = this;
      const filterOptions = items.map(i => i.value);
      const remainingSelections = sacTypesSelected
        .filter(item => filterOptions.includes(item));

      if (remainingSelections.length !== sacTypesSelected.length) {
        this.sacTypesSelected = remainingSelections;
      }
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .sac-filter__placeholder {
    font-size: 14px;
    color: #919191;
  }

  ::v-deep {
    input {
      font-size: 14px;
    }
  }
</style>
